import { Cents } from '@betterment/core';

import { EstimatedTradeTiming, TaxImpact } from '../../graphql/schema';

export type SellOrderProps = {
  accountId: string;
  securityId: string;
};

export enum SaleScope {
  SellAll = 1,
  SellPartial,
}

export enum OrderUnitType {
  Dollars = 'dollars',
  Shares = 'shares',
}

export type ValidatedOrderValues = {
  order_dollar_amount_cents?: Cents;
  order_shares_amount?: number;
  order_unit?: OrderUnitType;
  order_type?: SaleScope;
};

export type Validations = {
  estimated_trade_timing?: EstimatedTradeTiming;
  tax_impact_preview?: TaxImpact;
  sale_over_90_percent: boolean;
};
